import React from 'react';

function MatrixViewMode(props) {
    const options = props.questionData.selects[0].options;
    const isMatrixMultiple = props.questionData.options.multiple && props.questionData.options.multiple.localeCompare("true") === 0;
    const singleOrMultipleClass = isMatrixMultiple  ? "checkbox" : "radio";

    const buildHeadRow = () => {
        return options.map((option) => {
            return (
                <div key={"matrixHeadRow_" + option.label} className="questionaire__builder__question__form__cell">{option.label}</div>
            );
        });
    };

    const buildChoicesTable = () => {
        const rows = props.questionData.selects;
        return rows.map((row) => {
            return (
                <div key={"matrixChoicesTable_" + row.label} className="questionaire__builder__question__form__row">
                    <div className="questionaire__builder__question__form__cell">{row.label}</div>
                    {buildOptionsRow(row)}
                </div>
            );
        });
    };

    const buildOptionsRow = (row) => {
        const name = "matrix_" + row.id;
        return options.map((option) => {
            const matrixId = name + "_" + option.value;
            return (
                <div key={matrixId} className="questionaire__builder__question__form__cell">
                    <input type={singleOrMultipleClass} name={name} value={option.value} id={matrixId}/>
                    <label className="" htmlFor={matrixId}>
                        <span className={"questionaire__builder__question__form__cell__" + singleOrMultipleClass}></span>
                        <span className="questionaire__builder__question__form__check__text">{option.label}</span>
                    </label>
                </div>
            );
        });
    };

    return (
        <div className="questionaire__builder__question__form questionaire__builder__question__form--table">
            <div className="questionaire__builder__question__form__row questionaire__builder__question__form__row--head">
                <div className="questionaire__builder__question__form__cell"></div>
                {buildHeadRow()}
            </div>
            {buildChoicesTable()}
        </div>
    );
}

export default MatrixViewMode;